import css from './ReceiptNotFound.module.scss'
import React from 'react'
import { useTranslation } from 'react-i18next'

import Head from 'components/common/Head'
import Img from 'components/Media/Img'

const ReceiptNotFound: React.FC = () => {
  const { t } = useTranslation()

  return (
    <>
      <Head>
        <link href="https://fonts.googleapis.com/css?family=Nunito Sans" rel="stylesheet" />
      </Head>
      <div className={css.wrapper}>
        <div className={css.box}>
          <div className={css.logo}>
            <Img alt="TicketSMS Logo" src="/logo/TicketSms_logo.svg" />
          </div>

          <div className={css.image}>
            <Img alt="Live your time" src="/receipt/not_found.svg" />
          </div>

          <div className={css.text}>
            <span className={css.in_progress}>{t('receipt:receipt_not_found')}</span>
            <span className={css.wait_for}>{t('receipt:receipt_something_went_wrong')}</span>
          </div>
        </div>
      </div>
    </>
  )
}

export default ReceiptNotFound
